export const UNITS = {
  TRAY:  { label: 'Serves 12',     per: 12, perLabel: 'piece' },
  GUEST: { label: 'Per guest',     per: 1 },
  PORT:  { label: 'Per portion',   per: 1 },
  GLASS: { label: 'Per glass',     per: 1 },
  SLICE: { label: 'Per slice',     per: 1 },
  BOARD: { label: 'Per board',     per: 1 },
  JUG:   { label: '5 litres',      per: 1 },
  BULK:  { label: 'Bulk serving',  per: 1 },
};

export const CATERING_MENU = [
  {
    id: 'breakfast',
    name: 'Breakfast Spread',
    unitLabel: 'Each dish serves 12',
    note: "Our signature breakfast, scaled for events. Ideal for corporate mornings, bridal-party brunches and hotel-suite setups.",
    items: [
      { name: 'Pancakes',                  price: 24000, unit: 'TRAY' },
      { name: 'Chicken sandwich',          price: 42000, unit: 'TRAY' },
      { name: 'Egg and bacon sandwich',    price: 45000, unit: 'TRAY' },
      { name: 'Club sandwich',             price: 42000, unit: 'TRAY' },
      { name: 'Roasted potatoes',          price: 24000, unit: 'TRAY' },
      { name: 'Yam and egg / fish sauce',  price: 54000, unit: 'TRAY' },
      { name: 'Chicken sausage',           price: 24000, unit: 'TRAY' },
      { name: 'Baked beans',               price: 20400, unit: 'TRAY' },
      { name: 'Bacon',                     price: 30000, unit: 'TRAY' },
      { name: 'Muffins',                   price: 40000, unit: 'TRAY' },
      { name: 'Omelette',                  price: 26400, unit: 'TRAY' },
      { name: 'Egg sauce',                 price: 42000, unit: 'TRAY' },
      { name: 'Fish sauce',                price: 42000, unit: 'TRAY' },
      { name: 'Banana bread',              price: 42000, unit: 'TRAY' },
      { name: 'Doughnut',                  price: 30000, unit: 'TRAY' },
      { name: 'French toast',              price: 26400, unit: 'TRAY' },
      { name: 'Buttermilk waffles',        price: 26400, unit: 'TRAY' },
      { name: 'Mini croissant',            price: 24000, unit: 'TRAY' },
      { name: 'BLT croissant',             price: 54000, unit: 'TRAY' },
      { name: 'Tea break',                 price: 2500,  unit: 'GUEST', note: 'Tea, coffee and accompaniments' },
    ],
  },
  {
    id: 'canapes',
    name: 'Canapés & Fingerfoods',
    unitLabel: 'Each dish serves 12',
    note: 'Grazing food, cocktail hour and walk-around service. Twelve pieces per dish.',
    items: [
      { name: 'Beef / Chicken burger',            price: 54000, unit: 'TRAY' },
      { name: 'Hotdog',                           price: 44400, unit: 'TRAY' },
      { name: 'Chicken wrap',                     price: 54000, unit: 'TRAY' },
      { name: 'Spring roll',                      price: 18000, unit: 'TRAY' },
      { name: 'Cinnamon roll',                    price: 31000, unit: 'TRAY' },
      { name: 'Corn on cob',                      price: 24000, unit: 'TRAY' },
      { name: 'Chicken / Beef suya tacos',        price: 48000, unit: 'TRAY' },
      { name: 'Shrimp tacos',                     price: 56000, unit: 'TRAY' },
      { name: 'Beef / Crispy chicken baobun',     price: 57600, unit: 'TRAY' },
      { name: 'Waffles and chicken',              price: 54000, unit: 'TRAY' },
      { name: 'Cheese stuffed meatballs',         price: 30000, unit: 'TRAY' },
      { name: 'Potato croquettes',                price: 37200, unit: 'TRAY' },
      { name: 'Chicken lollipop',                 price: 36000, unit: 'TRAY' },
      { name: 'Gizdodo',                          price: 48000, unit: 'TRAY' },
      { name: 'Beef / plantain skewer',           price: 54000, unit: 'TRAY' },
      { name: 'Small chops',                      price: 42000, unit: 'TRAY' },
      { name: 'Moimoi',                           price: 24000, unit: 'TRAY' },
      { name: 'Plantain',                         price: 18000, unit: 'TRAY' },
    ],
  },
  {
    id: 'grills',
    name: 'Grills, Proteins & Peppersoup',
    unitLabel: 'Each dish serves 12',
    note: 'Carving-station and hot-service items. Best paired with one or two rice dishes.',
    items: [
      { name: 'Assorted meat peppersoup',            price: 57600, unit: 'TRAY' },
      { name: 'Chicken peppersoup',                  price: 57600, unit: 'TRAY' },
      { name: 'Spicy goatmeat',                      price: 60000, unit: 'TRAY' },
      { name: 'BBQ / Peppered turkey',               price: 72000, unit: 'TRAY' },
      { name: 'Grilled chicken',                     price: 60000, unit: 'TRAY' },
      { name: 'BBQ / Peppered / Suya chicken wings', price: 30000, unit: 'TRAY' },
      { name: 'Honey glazed chicken wings',          price: 30000, unit: 'TRAY' },
      { name: 'Croaker fish',                        price: 66000, unit: 'TRAY' },
      { name: 'Spicy beef',                          price: 33600, unit: 'TRAY' },
      { name: 'Lambchops',                           price: 51600, unit: 'TRAY' },
      { name: 'Garlic butter prawns',                price: 96000, unit: 'TRAY' },
    ],
  },
  {
    id: 'rice',
    name: 'Rice & Pasta',
    unitLabel: 'Mixed units — check each line',
    note: 'Tray dishes serve 12. The single-portion pastas and rice below are priced per plate, so they scale to any guest count.',
    items: [
      { name: 'Basmati jollof rice',    price: 57600, unit: 'TRAY' },
      { name: 'Special fried rice',     price: 57600, unit: 'TRAY' },
      { name: 'Coconut rice',           price: 60000, unit: 'TRAY' },
      { name: 'Asun rice',              price: 60000, unit: 'TRAY' },
      { name: 'Ofada rice / sauce',     price: 84000, unit: 'TRAY' },
      { name: 'Asun pasta',             price: 72000, unit: 'TRAY' },
      { name: 'Native pasta',           price: 6500,  unit: 'PORT' },
      { name: 'Creamy chicken pasta',   price: 7000,  unit: 'PORT' },
      { name: 'Chinese rice',           price: 5500,  unit: 'PORT' },
      { name: 'Prawn pasta',            price: 12000, unit: 'PORT' },
      { name: 'Oyster sauce / Sweet & sour sauce',   price: 4500, unit: 'PORT', note: 'Add-on sauce' },
      { name: 'Shredded beef sauce / Curry sauce',   price: 5000, unit: 'PORT', note: 'Add-on sauce' },
    ],
  },
  {
    id: 'sweet',
    name: 'Desserts & Fruit',
    unitLabel: 'Mixed units — check each line',
    note: 'Cups come in sets of 12. The fruit board and cake are priced individually.',
    items: [
      { name: 'Parfait cups',        price: 48000, unit: 'TRAY' },
      { name: 'Fruit cup',           price: 48000, unit: 'TRAY' },
      { name: 'Cake trifle cups',    price: 54000, unit: 'TRAY' },
      { name: 'Exotic fruit board',  price: 70000, unit: 'BOARD', note: 'Styled centrepiece board' },
      { name: 'Cake slice',          price: 4500,  unit: 'SLICE' },
    ],
  },
  {
    id: 'drinks',
    name: 'Drinks',
    unitLabel: 'Mixed units — check each line',
    note: 'A 5-litre dispenser pours roughly 20 × 250ml glasses.',
    items: [
      { name: 'Orange juice — 5L',     price: 27000, unit: 'JUG' },
      { name: 'Cranberry juice — 5L',  price: 32000, unit: 'JUG' },
      { name: 'Zobo',                  price: 25000, unit: 'BULK', note: 'Confirm volume on enquiry' },
      { name: 'Cocktails',             price: 6500,  unit: 'GLASS' },
      { name: 'Mocktails',             price: 5500,  unit: 'GLASS' },
    ],
  },
];

export const EVENTS_WHATSAPP = '2348094706381';
export const EVENTS_PHONE = '08094706381';
export const EVENTS_INSTAGRAM = 'https://instagram.com/sapore_eats';

export function nairaEvents(n) {
  return '\u20a6' + Math.round(n).toLocaleString('en-NG');
}

const IMG = (id) => `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=70&w=240&h=240&fit=crop`;

export const CATEGORY_IMAGES = {
  breakfast: [IMG('1621523132966-19f711d565d1'), IMG('1529940122574-0096689bc5cf'), IMG('1594012531621-23dc573ba808'), IMG('1535567465397-7523840f2ae9')],
  canapes:   [IMG('1763553113344-b6a32fcd9ffa'), IMG('1774806267007-d3f220542037'), IMG('1628578569073-8ee77295315d'), IMG('1616789663695-b80a1a9b429e')],
  grills:    [IMG('1599487488170-d11ec9c172f0'), IMG('1632158929413-168599fffbf7'), IMG('1705359573325-f2006d5e459f'), IMG('1626323109252-0adb3b46692b')],
  rice:      [IMG('1664992960082-0ea299a9c53e'), IMG('1665332195309-9d75071138f0'), IMG('1665556899022-9761f95769e5'), IMG('1664993101841-036f189719b6')],
  sweet:     [IMG('1571230389215-b34a89739ef1'), IMG('1771154136803-8df8e82e9765'), IMG('1568308853224-1f17b4084076'), IMG('1768851142262-26f602e069ed')],
  drinks:    [IMG('1603569283847-aa295f0d016a'), IMG('1551024709-8f23befc6f87'), IMG('1583577612013-4fecf7bf8f13'), IMG('1622597467821-df79dcb4f94d')],
};

export function thumbFor(catId, index) {
  const arr = CATEGORY_IMAGES[catId] || CATEGORY_IMAGES.breakfast;
  return arr[index % arr.length];
}

export function menuImageUrl(publicId, cloudName) {
  if (!publicId) return null;
  return `https://res.cloudinary.com/${cloudName}/image/upload/f_auto,q_auto,c_fill,ar_1:1,w_200/${publicId}`;
}
